import { render, staticRenderFns } from "./JSelectRole.vue?vue&type=template&id=644277f2&scoped=true"
import script from "./JSelectRole.vue?vue&type=script&lang=js"
export * from "./JSelectRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@7.1.2_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644277f2",
  null
  
)

export default component.exports